import React from 'react';
import styled from '@emotion/styled';
import Modal from '~/App/Components/Modal';
import { Button } from 'react-bootstrap';
import Text from '~/App/Components/Text';

export type AlertModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  message: string;
  title: string;
};

const ModalContentContainer = styled.div`
  text-align: center;
`;

const StyledModal = styled(Modal)`
  @media (max-width: 768px) {
    padding: unset;
  }
  > div {
    padding: 20px;
  }
`;

const Title = styled(Text.Heading)`
  border-bottom: 1px solid lightgray;
  padding-bottom: 12px;
  margin-top: unset;
`;

const AlertModal = ({
  isOpen,
  onRequestClose,
  message,
  title,
}: AlertModalProps) => {
  return (
    <StyledModal isOpen={isOpen} onRequestClose={onRequestClose} hideActions>
      <ModalContentContainer>
        <Title>{title}</Title>
        <Text.SubHeading>{message}</Text.SubHeading>
        <Button
          bsStyle='primary'
          onClick={onRequestClose}
          style={{ marginTop: 20 }}
        >
          Ok
        </Button>
      </ModalContentContainer>
    </StyledModal>
  );
};

export default AlertModal;
